import { hotTags, hotRanking, tickerItems } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="today" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-stretch lg:gap-12">
          <div className="w-full lg:w-[62%]">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5">
              <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" />
              <span className="text-xs font-medium tracking-wide text-primary-700">今日重磅 · 首发爆点已上线</span>
            </div>

            <h2 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
              今日重磅瓜料已经摆上桌，
              <br className="hidden md:block" />
              实锤证据、炸裂细节，
              <span className="text-primary-600">一次给全</span>。
            </h2>

            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              黑料大瓜持续追踪全网热门事件，最新爆料按分钟级更新，实锤原文、时间线还原、多方回应一站式汇总。
              吃瓜群众速来围观，不放过任何一个大瓜，这里有你想看的全部真相。
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#evidence"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-flashlight-fill" />
                看今日实锤
              </a>
              <a
                href="#flash"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-timer-flash-line" />
                进入快讯流
              </a>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              <span className="py-1.5 text-xs text-foreground-500">热搜词：</span>
              {hotTags.map((tag, i) => (
                <a
                  key={tag}
                  href="#hot"
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
                    i === 0
                      ? 'bg-accent-500 text-foreground-950 hover:bg-accent-600'
                      : 'bg-secondary-100 text-secondary-900 hover:bg-secondary-200'
                  }`}
                >
                  #{tag}
                </a>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[38%]">
            <div className="relative h-full overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative h-28 w-full md:h-32">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20moody%20city%20skyline%20at%20dusk%20with%20deep%20red%20and%20amber%20haze%2C%20blurred%20cinematic%20background%2C%20dramatic%20atmosphere%2C%20no%20people%2C%20no%20faces&width=800&height=320&seq=gossip-hero-sidebar&orientation=landscape"
                  alt="今日重磅爆料氛围图"
                  title="黑料大瓜 今日重磅 最新爆料"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent" />
                <div className="absolute bottom-3 left-4 flex items-center gap-2 text-background-50">
                  <i className="ri-bar-chart-box-line text-lg" />
                  <span className="font-heading text-lg font-bold">实时热搜榜</span>
                </div>
              </div>

              <ul className="divide-y divide-background-200">
                {hotRanking.slice(0, 5).map((item) => (
                  <li key={item.id}>
                    <a href="#hot" className="flex cursor-pointer items-center gap-3 px-4 py-3 transition-colors hover:bg-primary-50">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          item.rank <= 3
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-background-200 text-foreground-600'
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">{item.title}</span>
                      <span className="flex shrink-0 items-center gap-1 text-xs text-foreground-500">
                        <i
                          className={
                            item.trend === 'up'
                              ? 'ri-arrow-up-line text-primary-600'
                              : item.trend === 'down'
                                ? 'ri-arrow-down-line text-foreground-400'
                                : 'ri-subtract-line text-foreground-400'
                          }
                        />
                        {item.heat}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full border-t border-background-200 bg-foreground-950">
        <div className="mx-auto flex w-full max-w-[1400px] items-center px-4 md:px-6">
          <span className="flex shrink-0 items-center gap-2 py-3 pr-4 text-sm font-medium text-background-50">
            <span className="h-2 w-2 rounded-full bg-primary-500 animate-pulse-dot" />
            快讯流
          </span>
          <div className="relative flex-1 overflow-hidden py-3">
            <div className="flex w-max animate-marquee items-center gap-10">
              {[...tickerItems, ...tickerItems].map((item, i) => (
                <span key={`${item}-${i}`} className="whitespace-nowrap text-sm text-background-300">
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}